var _defs, _g, _line, _line2, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFereastra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b412e550-d87d-4c99-b273-e0a3096b8f22",
    "data-name": "fereastra",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b1a67e0b-a077-4002-b1f4-67f3113d678a,.e9a5d196-d78f-4a46-96db-94cb0bc40e65{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.e9a5d196-d78f-4a46-96db-94cb0bc40e65{stroke-width:10px;}.b1a67e0b-a077-4002-b1f4-67f3113d678a{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fereastra") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e7782bd0-4989-4a3c-baa4-fa34524fcf08",
    "data-name": "fereastra copy 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "e9a5d196-d78f-4a46-96db-94cb0bc40e65",
    points: "5 115.54 5 5 195 5 195 195 28.19 195"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e9a5d196-d78f-4a46-96db-94cb0bc40e65",
    x: 33.36,
    y: 30.21,
    width: 133.29,
    height: 139.58
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b1a67e0b-a077-4002-b1f4-67f3113d678a",
    x1: 137,
    y1: 41,
    x2: 158.5,
    y2: 62.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b1a67e0b-a077-4002-b1f4-67f3113d678a",
    x1: 111,
    y1: 42,
    x2: 157.5,
    y2: 88.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "e9a5d196-d78f-4a46-96db-94cb0bc40e65",
    points: "5 5 5 195 195 195"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFereastra);
export default __webpack_public_path__ + "static/media/fereastra.e48540b4fe56d4400d1a5f9a070b944b.svg";
export { ForwardRef as ReactComponent };